import { useHoverIntent } from '@hooks/useHoverIntent';
import SvgChevron from '@img/icons/chevron_right.svg';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from '../Header.styles';
const DesktopNavigation = (props) => {
    const [activeId, setActiveId] = React.useState('');
    const { ref: wrapperRef } = useHoverIntent({
        onBlur() {
            props.dropdownOpen(false);
        },
    });
    if (!props.links) {
        return null;
    }
    const handleActivateChange = (id) => {
        if (id) {
            setActiveId(id);
            props.dropdownOpen(true);
        }
        else {
            setActiveId('');
        }
    };
    return (React.createElement(S.DesktopNav, { ref: wrapperRef },
        React.createElement(S.Inner, { as: "ul" }, props.links.map((link) => (React.createElement(NavLink, { key: link.id, activeId: activeId, onActivateChange: handleActivateChange, ...link }))))));
};
const NavLink = (props) => {
    const [currentParent, setCurrentParent] = React.useState('');
    // const [hasChild, setHasChild] = React.useState(false);
    const { ref: anchorRef } = useHoverIntent({
        onHover() {
            props.onActivateChange(props.id);
        },
        onBlur() {
            props.onActivateChange();
            setCurrentParent('');
        },
    });
    function hasChild() {
        return props.children.map((link) => link.children?.some((group) => group));
    }
    const childNode = hasChild();
    return (React.createElement(S.DesktopNavItem, { ref: anchorRef, tabIndex: props.activeId !== props.id ? -1 : undefined, "data-is-active": props.activeId === props.id, onFocus: () => props.onActivateChange(props.id), onBlur: () => props.onActivateChange() },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.DesktopPrimaryNavLink, { href: props.url, target: props.target },
                props.text,
                ' ',
                props.children.length > 0 && (React.createElement(S.PlusIcon, null,
                    React.createElement(S.PlusHorizontal, null),
                    React.createElement(S.PlusVertical, null))))),
        props.children.length > 0 && (React.createElement(S.DropdownMenuWrapper, null,
            React.createElement(S.Inner, null,
                React.createElement(S.IntroColumn, null,
                    React.createElement(S.IntroTitle, null, props.text),
                    props.intro && React.createElement(S.IntroContent, null, props.intro)),
                React.createElement(S.DropdownMenuColumn, { "data-has-child": childNode.includes(true) },
                    React.createElement(S.ExtraPadding, null, props.children.map((link) => (React.createElement(S.DropdownMenuItem, { key: link.id, onMouseEnter: () => setCurrentParent(link.id), "data-is-active": link.children && currentParent === link.id },
                        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                            React.createElement(S.DropdownMenuLink, { href: link.url, target: link.target },
                                link.text,
                                " ",
                                link.children && link.children.length > 0 && React.createElement(SvgChevron, null)))))))),
                childNode.includes(true) &&
                    props.children.length > 1 &&
                    props.children.map((col, index) => (React.createElement(S.DropdownMultiLinkSection, { key: `dropdown-${props.id}-0${index + 1}`, "data-is-active": col.children && currentParent === col.id },
                        React.createElement(S.DropdownMenuColumn, null,
                            React.createElement(S.ExtraPadding, null, col.children?.map((group) => (React.createElement(S.DropdownMenuItem, { key: col.id, "data-group-header": true },
                                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                    React.createElement(S.DropdownMenuLink, { href: group.url, target: group.target }, group.text)))))))))))))));
};
export default DesktopNavigation;
